import ServerlessPlugin from './serverless-plugin'

module.exports = ServerlessPlugin
